import React from 'react';
import { Placemark } from 'react-yandex-maps';
import caption from 'assets/caption.svg';

const YCaption = React.memo(({ lat, lng, name }) => (
  <Placemark
    geometry={[+lat, +lng]}
    properties={{
      iconContent: `<div class="Caption">${name}</div`
    }}
    options={{
      iconLayout: 'default#imageWithContent',
      iconImageSize: [30, 42],
      iconImageOffset: [-15, -21],
      iconImageHref: caption
    }}
  />
));

export default YCaption;



// WEBPACK FOOTER //
// ./src/components/common/YMap/YCaption/index.js